import { ICustomerRecommendationsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisCustomerRecommendationsRepository from './implementations/VectisCustomerRecommendationsRepository';

let instance: ICustomerRecommendationsRepository | null = null;

export default function makeCustomerRecommendationsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisCustomerRecommendationsRepository(httpProvider);
  }

  return instance;
}
